import React, { useState, useEffect } from "react";
import $ from "jquery";
import "magnific-popup/dist/jquery.magnific-popup.min.js";
import "magnific-popup/dist/magnific-popup.css";
import "./ImageGrid.css";
import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const galleryItems = [
  { src: "image/Updated Renders - Barsana (1).jpg", category: "interior" },
  { src: "image/Updated Renders - Barsana (2).jpg", category: "interior" },
  { src: "image/Updated Renders - Barsana (3).jpg", category: "interior" },
  { src: "image/Updated Renders - Barsana (4).jpg", category: "interior" },
  { src: "image/Updated Renders - Barsana (5).jpg", category: "interior" },
  { src: "image/Updated Renders - Barsana (6).jpg", category: "interior" },
  { src: "image/Updated Renders - Barsana (7).jpg", category: "exterior" },
  { src: "image/Updated Renders - Barsana (8).jpg", category: "exterior" },
  { src: "image/Updated Renders - Barsana (9).jpg", category: "exterior" },
  { src: "image/Updated Renders - Barsana (10).jpg", category: "exterior" },
  { src: "image/Updated Renders - Barsana (11).jpg", category: "exterior" },
  { src: "image/Updated Renders - Barsana (12).jpg", category: "exterior" },
  { src: "image/Updated Renders - Barsana (13).jpg", category: "facilities" },
  { src: "image/Updated Renders - Barsana (14).jpg", category: "facilities" },
  { src: "image/Updated Renders - Barsana (15).jpg", category: "facilities" },
  { src: "image/Updated Renders - Barsana (16).jpg", category: "facilities" },
  { src: "image/Updated Renders - Barsana (17).jpg", category: "facilities" },
  { src: "image/Updated Renders - Barsana (18).jpg", category: "facilities" },


];

const filterTabs = [
  { label: "View All", value: "*" },
  { label: "Exterior", value: "exterior" },
  { label: "Interior", value: "interior" },
  { label: "Facilities", value: "facilities" },
];

const ImageGrid = () => {
  const [activeFilter, setActiveFilter] = useState("*");

  useEffect(() => {
    const items = document.querySelectorAll(".fade-in-up");

    items.forEach((item, idx) => {
      gsap.fromTo(
        item,
        {
          scale: 0.8,
          opacity: 0,
        },
        {
          scale: 1,
          opacity: 1,
          duration: 0.8,
          ease: "back.out(1.7)",
          delay: idx * 0.05,
          scrollTrigger: {
            trigger: item,
            start: "top 90%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });
  }, [activeFilter]);

  useEffect(() => {
    $(".image-popup").magnificPopup({
      type: "image",
      gallery: { enabled: true },
      mainClass: "mfp-with-zoom",
      image: {
        markup: `
      <div class="mfp-figure">
      
     <button title="Close (Esc)" type="button" class="mfp-close">×</button>

        <figure>
        
          <div class="mfp-img"></div>
         
           
          <figcaption>
            <div class="mfp-bottom-bar">
              <div class="mfp-title"></div>
              <div class="mfp-counter"></div>
            </div>
          </figcaption>
        </figure>
      </div>`,
      },
    });
  }, []);

  const visibleItems = galleryItems.filter((item) =>
    activeFilter === "*" ? true : item.category === activeFilter
  );

  return (
    <section id="section-gallery" className="bg-color-op-1">
      <div className="container">
        <div className="row g-4 justify-content-center">
          <div className="col-lg-6 text-center">
            <div
              id="subtitle"
              className=" s2 mb-3 wow fadeInUp"
              data-wow-delay=".0s"
            >
              Discover Gallery
            </div>
            <h3
              className="wow fadeInUp"
              data-wow-delay=".2s"
              style={{ marginBottom: "25px" }}
            >
              Exterior &amp; Interior
            </h3>
          </div>
        </div>

        
        <div className="row">
          <div className="col-md-12 text-center mb-4">
            <ul
              id="filters"
              className="wow fadeInUp list-inline"
              data-wow-delay="0s"
            >
              {filterTabs.map((tab) => (
                <li key={tab.value} className="list-inline-item">
                  <a
                    href="#"
                    data-filter={tab.value === "*" ? "*" : `.${tab.value}`}
                    className={activeFilter === tab.value ? "selected" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveFilter(tab.value);
                    }}
                  >
                    {tab.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Gallery Items */}
        <div id="gallery" className="row g-3 wow fadeInUp" data-wow-delay=".3s">
          {visibleItems.map((item, idx) => (
            <div
              key={`${item.src}-${activeFilter}-${idx}`}
              className={`col-lg-4 col-sm-6 col-6 item ${item.category} fade-in-up`}
            >
              <a href={item.src} className="image-popup  hover">
                <div className="position-relative overflow-hidden rounded">
                  <div className="position-absolute w-100 p-5 text-center text-white z-2 top-50 start-50 translate-middle">
                    View
                  </div>
                  <div className="position-absolute overlay-dark-7 z-1" />
                  <img
                    src={item.src}
                    className="hover-scale-1-2"
                    alt={`Gallery ${idx + 1}`}
                    style={{ height: "300px", width: "100%" }}
                  />
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImageGrid;
